<template>
  <div :class="className">
    <div class="icon">
      <a-icon :type="icon" />
    </div>
    <div class="state-description">
      {{ description }}
      <div class="sub-description"> {{ subDescription }} </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: 'state.item',
  props: {
    propsClassName: {
      type: String,
      default: 'state',
    },
    description: {
      type: String,
    },
    subDescription: {
      type: String,
    },
    completed: {
      type: Boolean,
    },
    danger: {
      type: Boolean,
    },
    active: {
      type: Boolean,
    },
    icon: {
      type: String,
    },
  },
  computed: {
    className () {
      if (this.completed) {
        return [this.propsClassName, 'completed'].join(' ');
      } else if (this.active) {
        return [this.propsClassName, 'active'].join(' ')
      } else if (this.danger) {
        return [this.propsClassName, 'danger'].join(' ')
      } else {
        return this.propsClassName
      }
    },
  },
}
</script>

<style lang="sass">
.state
  text-align: center
  position: relative
  width: 100%
  // display: flex
  padding: 1rem 0
  align-items: center
  // padding-top: 0
  padding-bottom: 0
  display: block
  width: auto
  flex-grow: 1

  &:before,
  &:after
    position: absolute
    content: ''
    // z-index: -1
    background: #ccc
    height: 3px
    width: 50%
    //left: auto
    top: calc(75px / 2)
    //left: calc(55px / 2)

  &:before
    left: 0

  &:after
    bottom: auto
    right: -27px


  .icon
    width: 55px
    height: 55px
    position: relative
    border-radius: 50rem
    border-style: solid
    border-width: 3px
    background: #ffffff
    border-color: #ccc
    // margin-right: 1rem
    margin: auto;

    i
      color: #ccc
      font-size: 2rem
      position: absolute
      top: 50%
      left: 50%
      transform: translate(-50%, -50%)

  .state-description
    color: #aaa
    margin-top: 1rem
    
    .sub-description
      color: #999999
      font-size: .75rem

  &:first-child
    &:before
      width: 0

  &:last-child
    &::after
      width: 0%

  &.completed,
  &.active
    .state-description
      color: initial

  &.completed
    &:after,
    &:before
      background: #6E79FD
      background: blue
    .icon
      border-color: #6E79FD
      border-color: blue
      i
        color: #6E79FD
        color: blue

  &.active
    &:before
      background: #6E79FD
      background: blue
    .icon
      background: #6E79FD
      background: blue
      border-color: #6E79FD
      border-color: blue
      
      i
        color: #ffffff

  
  &.danger
    &:before
      background: red
    .icon
      border-color: red
      
      i
        color: red
</style>
